import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { OgrenciError } from "../../types/ErrorModals/OgrenciError";
import { OgrenciRequestModal } from "../../types/RequestModals/OgrenciRequestModal";
import { OgrenciEkleRequestModal, OgrenciGuncelleRequestModal, OgrenciOdemeResponseModal, OgrenciResponseModal, OgrenciTaksitResponseModal, TaksitPlanRequestModal } from "../../types/modals";
import { OgrenciOdemeEkleRequestModal } from "../../types/RequestModals/OgrenciOdemeEkleRequestModal";
import { OgrenciOdemeRequestModal } from "../../types/RequestModals/OgrenciOdemeRequestModal"; 

export const getOgrenciler = async (
  request: OgrenciRequestModal
): Promise<OgrenciResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<OgrenciResponseModal[]>>(
      `${API_URL}/api/Ogrenci/getOgrenciler`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const getOgrenciOdemeleri = async (
  request: OgrenciOdemeRequestModal
): Promise<OgrenciOdemeResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<OgrenciOdemeResponseModal[]>>(
      `${API_URL}/api/Ogrenci/getOgrenciOdemeleri`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci ödemesi bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const addOgrenciOdeme = async (
  request: OgrenciOdemeEkleRequestModal
): Promise<void> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/Ogrenci/addOgrenciOdeme`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

// Yeni Eklenen Servisler

export const getOgrenciTaksitPlan = async (
  kurumKodu: string,
  ogrenciId: number,
  sezon: number
): Promise<OgrenciTaksitResponseModal> => {
  try {
    const response = await axios.get<ApiResponse<OgrenciTaksitResponseModal>>(
      `${API_URL}/api/Ogrenci/getOgrenciTaksitPlan/${kurumKodu}/${ogrenciId}/${sezon}`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Taksit planı bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const createTaksitPlan = async (
  request: TaksitPlanRequestModal
): Promise<void> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/Ogrenci/createTaksitPlan`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const odeTaksit = async (
  kurumKodu: string,
  taksitId: number,
  tutar: number,
  odemeTuru: string = "Nakit",
  aciklama: string = "EĞİTİM"
): Promise<void> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/Ogrenci/odeTaksit/${kurumKodu}/${taksitId}?tutar=${tutar}&odemeTuru=${odemeTuru}&aciklama=${aciklama}`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Taksit bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const addOgrenci = async (
  request: OgrenciEkleRequestModal
): Promise<number> => {
  try {
    const response = await axios.post<ApiResponse<number>>(
      `${API_URL}/api/Ogrenci/addOgrenci`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const updateOgrenci = async (
  request: OgrenciGuncelleRequestModal
): Promise<void> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/Ogrenci/updateOgrenci`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};

export const deleteOgrenci = async (
  kurumKodu: string,
  ogrenciId: number
): Promise<void> => {
  try {
    const response = await axios.delete<ApiResponse>(
      `${API_URL}/api/Ogrenci/deleteOgrenci/${kurumKodu}/${ogrenciId}`
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci bulunamadı",
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as OgrenciError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as OgrenciError;
    }
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as OgrenciError;
  }
};